import { Outlet } from "react-router-dom";
import OrganizationList from "ui/organization/organization-list";
import OrganizationProvider from "context/OrganizationContext";
import TopNav from "ui/dashboard/topnav";

export default function Layout() {
  return (
    <>
      <OrganizationProvider>
        <TopNav title="Organization" />
        <div className="flex h-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl mr-6 mb-6">
          <div
            className="w-full flex-none md:w-96 border-r border-neutral-200 py-6"
            style={{ height: "calc(100% - 24px)" }}
          >
            <OrganizationList />
          </div>
          <div className="flex-grow flex flex-col h-full  items-center overflow-auto">
            <Outlet />
          </div>
        </div>
      </OrganizationProvider>
    </>
  );
}
